import styled from "styled-components";
import Grid from "../grid/Grid";


const StyledCategoryGrid = styled(Grid)<{ view: string }>
`
    padding : 0.15rem;
    padding-top : 5px;
    margin-bottom : 1.5rem;
   
   

    @media only screen and (min-width : 1025px ){
        padding-top : 0;

        flex-basis : ${(p) =>  p.view === 4 ? '33%' : '25%'}
        //flex: 1 0 25%;
        //max-width : 25%;


     }


     img{
        transition: transform 0.5s ease;
        overflow:hidden;
     }

     a{
        overflow:hidden;
     }

     img:hover{
        transform : scale(1.05);

     }





`

export default StyledCategoryGrid